import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import "./app.css";
import AppStatusBanner from "./Components/AppStatusBanner/AppStatusBanner";
import RenderCompleteListener from "./Components/RenderCompleteListener/RenderCompleteListener";

function App() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <AppStatusBanner />
      <BrowserRouter>
        <RenderCompleteListener />
        <Routes />
      </BrowserRouter>
    </div>
  );
}

export default App;
